export default __webpack_public_path__ + "static/media/nayeon3.c2aa25f9.jpg";